import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Header from "components/organisms/header";
import Footer from "components/organisms/footer";
import SectionHero from "components/organisms/sectionHero";
import RequestForm from "components/organisms/requestForm";
import FormContent from "components/organisms/formContent/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import "./styles.scss";

import { fetchVehicleParameter, requestVehicle } from "actions/vehicle";

class Request extends React.Component {
  handleSubmit(values) {
    this.props.request(values);
  }

  componentDidMount() {
    this.props.fetch("brand");
    this.props.fetch("model");
    this.props.fetch("engine");
    this.props.fetch("body");
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Encontrar vehículo usado a medida - Territorio Yacopini</title>
          <meta
            name="description"
            content="Contanos qué buscás y lo encontraremos por vos"
          />
        </Helmet>
        <Header />
        <SectionHero style="orange">
          <h1>Tu auto a medida.</h1>
          <p>
            ¿No encontrás el auto ideal para vos? En Yacopini te ayudamos a
            buscarlo. Completá el formulario y te informaremos cuando
            encontremos vehículos que coincidan con tu pedido.
          </p>
        </SectionHero>

        {this.props.isFetching === true && (
          <FormContent>
            <FormFieldset>
              <h3>Cargando...</h3>
            </FormFieldset>
          </FormContent>
        )}

        {this.props.error === true && (
          <FormContent>
            <FormFieldset>
              <h3>Hubo un error enviando tu pedido.</h3>
              Por favor intentalo nuevamente más tarde.
            </FormFieldset>
          </FormContent>
        )}

        {!this.props.isFetching &&
          !this.props.requestSent &&
          !this.props.error && (
            <RequestForm
              brands={this.props.brands}
              models={this.props.models}
              engines={this.props.engines}
              bodies={this.props.bodies}
              onSubmit={this.handleSubmit.bind(this)}
            />
          )}

        {this.props.requestSent === true && (
          <FormContent>
            <FormFieldset>
              <h3>Pedido enviado.</h3>
              <p className="b">
                Te estaremos informando cuando encontremos un usado que se
                ajuste a tus preferencias.
              </p>
            </FormFieldset>
          </FormContent>
        )}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brands: state.vehicle.brands,
    models: state.vehicle.models,
    engines: state.vehicle.engines,
    bodies: state.vehicle.bodies,
    isFetching: state.vehicle.isFetching,
    requestSent: state.vehicle.requestSent,
    error: state.vehicle.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (parameter) => {
      dispatch(fetchVehicleParameter(parameter));
    },
    request: (data) => {
      dispatch(requestVehicle(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Request);
